import { render, staticRenderFns } from "./AromaReportHistoryItem.vue?vue&type=template&id=2eb7fef2&scoped=true"
import script from "./AromaReportHistoryItem.vue?vue&type=script&lang=js"
export * from "./AromaReportHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./AromaReportHistoryItem.vue?vue&type=style&index=0&id=2eb7fef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7fef2",
  null
  
)

export default component.exports